import { ChangeDetectionStrategy, Component, Injector } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DirectiveSuperclass } from '@sama/ng-core';
import { EventTrackingService } from '../../../../shared/event-tracking/event-tracking.service';
import { ScrollEventsListener } from '../../../../shared/event-tracking/scroll-tracking/scroll-events-listener';

@Component({
  selector: 'h3-page-scroll-tracking',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PageScrollTrackingComponent extends DirectiveSuperclass {
  constructor(
    dialog: MatDialog,
    eventTrackingService: EventTrackingService,
    injector: Injector,
  ) {
    super(injector);
    new ScrollEventsListener(
      window,
      this,
      eventTrackingService,
      'page',
      dialog,
    ).startListening(() => [window.scrollX, window.scrollY], {
      source: 'page',
    });
  }
}
